import i18n from 'lib/i18next';

export function determineHighestNumberFactory(field) {
  return ({ vehicle1, vehicle2 }) => {
    if (!vehicle1[field] || !vehicle2[field]) {
      return null;
    }

    if (vehicle1[field] > vehicle2[field]) {
      return vehicle1;
    }
    if (vehicle2[field] > vehicle1[field]) {
      return vehicle2;
    }

    return null;
  };
}

export function determineLowestNumberFactory(field) {
  return ({ vehicle1, vehicle2 }) => {
    if (!vehicle1[field] || !vehicle2[field]) {
      return null;
    }

    if (vehicle1[field] < vehicle2[field]) {
      return vehicle1;
    }
    if (vehicle2[field] < vehicle1[field]) {
      return vehicle2;
    }

    return null;
  };
}

export function formatFeatureFactory(feature) {
  return (vehicle) => {
    if (!vehicle[feature]) {
      return 'N/A';
    }

    if (vehicle[feature] === 'Not Available') {
      return '-';
    }

    return i18n.t(
      `comparison.lineItems.features.availability.${vehicle[
        feature
      ].toLowerCase()}`
    );
  };
}

function isStandard(vehicle, feature) {
  return vehicle[feature] === 'Standard';
}

function isAvailable(vehicle, feature) {
  return vehicle[feature] === 'Available';
}

export function determineBestFeatureCapability(vehicle1, vehicle2, feature) {
  // Standard is best.
  if (isStandard(vehicle1, feature) && !isStandard(vehicle2, feature)) {
    return vehicle1;
  }
  if (isStandard(vehicle2, feature) && !isStandard(vehicle1, feature)) {
    return vehicle2;
  }

  // Available is second best.
  if (isAvailable(vehicle1, feature) && !isAvailable(vehicle2, feature)) {
    return vehicle1;
  }
  if (isAvailable(vehicle2, feature) && !isAvailable(vehicle1, feature)) {
    return vehicle2;
  }

  // If neither is standard or available, then neither wins.
  return null;
}

export function determineBestFeatureCapabilityFactory(feature) {
  return ({ vehicle1, vehicle2 }) => {
    if (!vehicle1[feature] || !vehicle1[feature]) {
      return null;
    }

    return determineBestFeatureCapability(vehicle1, vehicle2, feature);
  };
}
